<template>
    <div class="TQ_inline " >


        <tq-image :pb_src_r="co_img_r " @click.native.stop="m_showMoreInfo_f" v-if="co_img_r"
                  class="TQ_width_100p TQ_clickable TQ_verticalAlignMiddle TQ_bg_circle TQ_Animation_smallBigSmall_infinite_hover" > </tq-image>

        <div v-else @click.stop="m_showMoreInfo_f">
            <slot></slot>
        </div>

        <tq-popup :show="showPopup_vb" max-width="800px" show-close-btn>

            <fcc-display-slides-data v-if="moreInfo_c && showPopup_vb.val"
                                      :pe_click-finish_f="() => {showPopup_vb.val = false}"
                                      :p_slide-height_s="co_moreInfoHeight_s"
                                      :p_slides-data_ac="moreInfo_c.so_slides_blc_ac[moreInfo_c.ml_m_displayLang_fe(store_systemLangCode_ve.val)]"/>

            <tq-image v-else-if="moreInfo_c === null" :pb_src_r="ass_image_coming_soon" class="TQ_width_100p" />

        </tq-popup>

    </div>
</template>

<script>
import {
    ass_image_coming_soon,
    ass_img_info2_b,
    ass_img_info2_w, ass_svg_gearHelper_b,
    ass_svg_gearHelper_w
} from "@/assets/scripts/Ass_Files";
    import TqImage from "../basic/TqImage";
    import {serverPre_moreInfo_get_one_f} from "@/scripts/Server/S_ServerPre";
    import {store_getStateValue_vo, store_var} from "@/store";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {enum_moreInfoImgOptions_e, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
import TqPopup from "@/components/basic/TqPopup";
import FccDisplaySlidesData from "@/components/complex/TqDisplaySlidesData";
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";

    export default {
        name: "TqMoreInfo",
        components: {FccDisplaySlidesData, TqPopup, TqImage},
        props:{
            p_moreInfoId_uid:{
                type: String,
                require: true
            },
            p_img_e:{
                type: String,
                default: enum_moreInfoImgOptions_e.ass_img_info2_b,
                validator (val){
                    return validator_enum_fb(enum_moreInfoImgOptions_e, val)
                }
            }
        },
        data(){
            return {
                showPopup_vb : {val : false},
                moreInfo_c : undefined,

                // store
                store_systemLangCode_ve : store_getStateValue_vo(store_var.system_langCode),
                store_windowSizeType_ve : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // import
                ass_strings : ass_strings,
                ass_image_coming_soon : ass_image_coming_soon,
            }
        },
        computed: {
            co_moreInfoHeight_s(){

                switch(this.store_windowSizeType_ve.val){

                    case enum_screenSizesOptions_n.mobile:
                        return '200px'
                    case enum_screenSizesOptions_n.tablet_small:
                        return '300px'
                    case enum_screenSizesOptions_n.tablet_big:
                        return '400px'
                    case enum_screenSizesOptions_n.laptop:
                        return '500px'
                }
            },
            co_img_r(){
                switch(this.p_img_e){
                    case enum_moreInfoImgOptions_e.ass_img_info2_b:
                        return ass_img_info2_b
                    case enum_moreInfoImgOptions_e.ass_img_info2_w:
                        return ass_img_info2_w
                    case enum_moreInfoImgOptions_e.ass_img_featureHelper_w:
                        return ass_svg_gearHelper_w
                    case enum_moreInfoImgOptions_e.ass_img_featureHelper_b:
                        return ass_svg_gearHelper_b
                }
            }
        },
        methods:{
            m_showMoreInfo_f(){
                this.showPopup_vb.val = true

                if(this.moreInfo_c === undefined){

                    serverPre_moreInfo_get_one_f({
                        mi_id_uid: this.p_moreInfoId_uid,
                        cb_f : (moreInfo_c) => {
                            this.moreInfo_c = moreInfo_c
                        }
                    })
                }

            }
        }
    }
</script>

<style scoped lang="scss">
.lc_tqText {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000px;
    animation: color 3s linear forwards infinite;
}

.lc_maze {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000px;
    animation: dash 3s linear forwards;
}

@keyframes dash {
    0% {
    }
    70% {
        stroke-dashoffset: 0
    }
    100% {
        stroke-dashoffset: 0
    }
}

@keyframes color {
    0% {
        stroke: #885ead;
    }
    5% {
        stroke: #885ead;
        stroke-dashoffset: 1000px;
    }
    50% {
        stroke: #885ead;
    }
    60% {
        stroke: white;
    }
    90% {
        stroke-dashoffset: 0
    }
    100% {
        stroke: white;
        stroke-dashoffset: 0
    }

}
</style>